import { render, staticRenderFns } from "./Ntsa.vue?vue&type=template&id=15f3a32c&scoped=true"
import script from "./Ntsa.vue?vue&type=script&lang=js"
export * from "./Ntsa.vue?vue&type=script&lang=js"
import style0 from "./Ntsa.vue?vue&type=style&index=0&id=15f3a32c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3a32c",
  null
  
)

export default component.exports